import { Box, Text, Grid, GridItem, Flex, VStack, Center } from "@chakra-ui/react";

export default function About() {
  return (
    <Box

      bg="#0C040F"
      color="white"
      py={{ base: 16, md: 22 }}
      px={{ base: 6, md: 12 }}
      position="relative"
      overflow="hidden"
    >

      {/* <Box
        position="absolute"
        top="15%"
        right="1000px"
        w="1000px"
        h="600px"
        bg="radial-gradient(circle, rgba(167,139,250,0.4) 0%, rgba(0,0,0,0) 70%)"
        filter="blur(120px)"
        zIndex={0}
      /> */}

      <Box mx="auto" position="relative" zIndex={1}>
        {/* Title */}
        <Text
          textAlign="center"
          fontSize={{ base: "60px", md: "126px" }}
          fontWeight="bold"
          bgGradient="linear(to-r, #FFFFFF, #BDA8FB)"
          bgClip="text"
          mb={4}
        >
          About Us
        </Text>

        <Text
          textAlign="center"
          fontSize={{ base: 33, md: 46 }}
          bgGradient={"linear(to-r, #8B5CF6, #D946EF)"}
          bgClip={"text"}
          fontWeight="bold"
          mb={2}
        >
          Where It All Begins
        </Text>
        <Text color={"#9CA3AF"} fontSize={"20px"} textAlign={"center"} mb={4}>
          Everything you need to know before starting your journey
        </Text>
        <Text
          textAlign="center"
          color="#A78BFA"
          maxW="900px"
          mx="auto"
          mb={12}
          lineHeight="1.7"
          fontSize={21}
        >
          Winnsta builds skill-based mobile games that are easy to start and fun to master, for players of all ages.Every game is coin-only: no wagering, no cash out, and no real-money gameplay.
        </Text>
        <Box
          position="absolute"
          top="26%"
          right="-300px"
          w="550px"
          h="300px"
          bg="radial-gradient(circle, #8B5CF6 0%, rgba(0,0,0,0) 70%)"
          filter="blur(120px)"
          zIndex={-1}
          pointerEvents="none"
        />
        {/* Mission & Vision */}
        <Grid
          templateColumns={{ base: "1fr", md: "1fr 1fr" }}
          gap={8}
          mb={16}
          textAlign={"center"}
        >
          <Box
            p={8}
            borderRadius="2xl"
            bg="linear-gradient(180deg, #2E0F41, #7626A7)"
            backdropFilter="blur(12px)"
            border="0px solid rgba(167,139,250,0.3)"
            zIndex={1}
          >
            <Text fontSize={{ base: 30, md: 70 }} fontWeight="bold" mb={3}>
              OUR MISSION
            </Text>
            <Text color="gray.300" fontSize={21}>
              Keep gameplay clean, fair, and skill-first. Make quick sessions that still feel competitive. Build a playful app that’s safe for everyone to enjoy.
            </Text>
          </Box>

          <Box
            p={8}
            borderRadius="2xl"
            bg="linear-gradient(180deg, #2E0F41, #7626A7)"
            backdropFilter="blur(12px)"
            border="0px solid rgba(167,139,250,0.3)"
          >
            <Text fontSize={{ base: 30, md: 70 }} fontWeight="bold" mb={3}>
              OUR VISION
            </Text>
            <Text color="gray.300" fontSize={21}>
              We envision a galaxy of gamers connected through fair play, fast action, and high-stakes fun — with real rewards and an evolving metaverse of entertainment.
            </Text>
          </Box>
        </Grid>

        <Text textAlign={"center"} mb={6} bgGradient={"linear(to-r, #D946EF,#8B5CF6)"} bgClip={"text"} fontWeight={"bold"} fontSize={25}>Chips are just for in-game play—they have no real-world cash value and can’t be withdrawn.</Text>

        {/* Two Columns */}
        <Box bg="rgba(180, 80, 242, 0.11)"
          backdropFilter="blur(12px)"
          border="1px solid rgba(255,255,255,0.08)"
          borderRadius="70px"
          p={{ base: 6, md: 12 }}
          boxShadow="0 8px 40px rgba(139,92,246,0.15)"
          overflow="visible">
          <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={{base:10,md:32}} mb={16} mt={16} position="relative">
            {/* Glow behind right column */}


            {/* Left */}
            <Box>
              <Text
                bgGradient="linear(to-r, #8B5CF6, #D946EF)"
                bgClip="text"
                fontSize={{ base: 30, md: 44 }}
                fontWeight="bold"
                mb={{ base: 0, md: 4 }}
              >
                Driven by Core Values
              </Text>

              <VStack align="start" spacing={2} fontSize={21}>
                {[
                  ["Skill Over Chance", "We believe in strategy gameplay and skill-based outcomes."],
                  ["Sportsmanship", "Healthy competition and fair play form the core of our gaming ethos."],
                  ["Trust & Transparency", "Your time, effort, and money are respected. Our platform is secure and community-first."],
                  ["Innovation-Led", "From real-time scoring engines to futuristic UI — we invest in experiences, not just apps."],
                ].map(([title, desc], i) => (
                  <VStack key={i} align="start" spacing={0}>
                    <Text color="#A78BFA">• {title} :</Text>
                    <Text pl={{ base: 6, md: 3 }} color="white">{desc}</Text>
                  </VStack>
                ))}
              </VStack>

              <Text
                bgGradient="linear(to-r, #8B5CF6, #D946EF)"
                bgClip="text"
                fontWeight="bold"
                fontSize={{ base: 34, md: 46 }}
                mt={8}
                mb={3}
              >
                Who We Are
              </Text>

              <VStack align="start" spacing={2} fontSize={21}>
                <VStack align="start" spacing={0}>
                  <Text color="#A78BFA">• Founders & Tech Leaders :</Text>
                  <Text pl={{ base: 6, md: 3 }} color="white">
                    A team of game designers, fantasy strategists, coders, and sports addicts
                  </Text>
                </VStack>

                <Text>
                  <Text as="span" color="#A78BFA">• Headquarters :</Text> Goa
                </Text>

                <Text>
                  <Text as="span" color="#A78BFA">• App Launch :</Text> Pan India
                </Text>
              </VStack>
            </Box>

            {/* Right */}
            <Box position="relative" zIndex={1}>
              <Text
                bgGradient="linear(to-r, #8B5CF6, #D946EF)"
                bgClip="text"
                fontSize={{ base: 34, md: 46 }}
                fontWeight="bold"
                mb={{ base: 0, md: 4 }}
              >
                Built for Every Player
              </Text>

              <VStack align="start" spacing={2} fontSize={21}>
                {[
                  ["For the Fantasy Fanatic", "Draft, captain, trade — win points based on real match starts."],
                  ["For the Casual Gamer", "One-minute, high-speed games that test reflex, memory, and focus."],
                  ["For the Community", "Public leagues, private rooms, and player chat. Play together, rise together."],
                  ["Innovation-First", "We invest in experiences, not just apps."],
                ].map(([title, desc], i) => (
                  <VStack key={i} align="start" spacing={0}>
                    <Text color="#A78BFA">• {title} :</Text>
                    <Text pl={{ base: 6, md: 3 }} color="white">{desc}</Text>
                  </VStack>
                ))}
              </VStack>
            </Box>
          </Grid>
        </Box>


        {/* Bottom CTA Card */}
        <Box
          position="absolute"
          top="70%"
          right="1200px"
          w="400px"
          h="600px"
          bg="radial-gradient(circle, rgba(167,139,250,0.4) 0%, rgba(0,0,0,0) 70%)"
          filter="blur(120px)"
          zIndex={-1}
          pointerEvents="none"
        />
        <Box
          mx={{ md: 12, base: 4 }}
          p={{ base: 8, md: 8 }}
          mt={{ base: 8, md: 28 }}
          borderRadius="2xl"
          bg="rgba(167,139,250,0.15)"
          backdropFilter="blur(12px)"
          border="1px solid rgba(167,139,250,0.4)"
          textAlign="center"
        >
          <Text fontSize={{ base: "24px", md: "60px" }} fontWeight="bold" mb={2}>
            Game. Fair. Always.
          </Text>

          <Text color="gray.200" maxW="800px" mx="auto" fontSize={{ base: 18, md: 21 }}>
            Winnsta is fully compliant with Indian gaming laws. Our games are crafted fair,
            we’ve invested best practices in responsible gaming to protect both new and veteran players.
          </Text>

          <Text bgGradient={"linear(to-r, #D946EF, #8B5CF6, )"} bgClip={"text"} fontWeight="bold" fontSize={{ base: 16, md: 33 }} mt={4}>
            Gaming isn’t just a pastime here — it’s a platform to rise, to connect, and to win.
          </Text>
        </Box>
      </Box>
    </Box>
  );
}
